import type { CSSProperties } from "react";

import styled from "styled-components";

import { Box } from "@similarweb/ui-components/foundations";

export const ChartWithLegend = styled.div<{ flexDirection?: CSSProperties["flexDirection"] }>`
    height: 100%;
    width: 100%;
    overflow: auto;
    display: flex;
    flex-direction: ${({ flexDirection = "row" }) => flexDirection};
    justify-content: center;
    padding: 0 20px;
    box-sizing: border-box;
`;

export const WidgetWrapper = styled(Box)`
    & [class^="BodyWrapper"] {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const LegendsContentContainer = styled.div`
    height: 100%;
    width: 100%;
`;
